import { Controller } from "@hotwired/stimulus"
import { Modal, Tab } from "bootstrap"

export default class extends Controller {
  static targets = ["modal", "tab"]

  open({ params: { tier } }) {
    Tab.getOrCreateInstance(this.tabTargets.find((tab) => tab.dataset.tier === tier)).show()
    Modal.getOrCreateInstance(this.modalTarget).show()
  }
}
